import * as React from 'react';
import styled from '@emotion/styled';

interface PropsType {
    className?: string;
}

const SvgElement = styled('svg', { label: 'SvgElement' })<PropsType>`
    height: auto;
`;

export const BetWrightLogo = ({ className }: PropsType): React.ReactElement => (
    <SvgElement
        xmlns='http://www.w3.org/2000/svg'
        width='148'
        height='20'
        fill='none'
        viewBox='0 0 148 20'
        className={className}
    >
        <path
            fill='#F9F9F9'
            d='m61.697.319 3.662 13.95L68.73.319h4.65l-5.521 19.305H63.47l-3.4-13.256-3.372 13.256h-4.388L46.761.319h4.62l3.4 13.95L58.472.319M83.464 12.271c2.092-.492 4.243-2.315 4.243-5.73 0-3.59-2.47-6.223-6.51-6.223h-6.654L72.13 8.753v10.87h4.127v-6.917h3.022l3.807 6.917h4.737l-4.36-7.352Zm-2.878-3.096h-4.33V3.85h4.33c1.657 0 2.906 1.042 2.906 2.662 0 1.62-1.249 2.663-2.906 2.663ZM88.523.319v15.91l2.013 3.394h2.114V.319h-4.127ZM102.993 12.503h5.158v2.344c-.843.752-2.412 1.476-4.185 1.476-3.517 0-6.074-2.692-6.074-6.338 0-3.647 2.557-6.338 6.074-6.338a5.506 5.506 0 0 1 4.591 2.43l3.429-1.851C110.504 1.939 107.976 0 103.966 0c-5.668 0-10.317 3.878-10.317 9.986 0 6.107 4.65 10.014 10.317 10.014 3.516 0 6.277-1.447 8.253-3.647v-7.38l-8.332-.062M126.619 11.519h-9.153v8.104h-4.127V.319h4.127v7.583h9.153V.32h4.156v19.305h-4.156V11.519ZM147.333.337V.32h-.018l.018.018ZM147.29.319h-15.418v3.618h5.667v15.686h4.156V3.937h5.638l-1.776-1.892L147.29.319Z'
        />
        <path
            fill='#FFCE00'
            d='M46.767 3.937h-3.978v15.686h-4.156V3.808h-5.666v-.026l-1.761-1.721L32.967.339V.318h12.76l1.04 3.619Z'
        />
        <path
            fill='#FFCE00'
            d='M31.528 3.873V3.51l-1.485-1.45L31.528.609V.342H17.811v19.304h13.717v-3.56h-9.59V11.6h9.386V8.07h-9.386V3.873h9.59ZM13.104 9.67c1.831-.376 3.343-1.997 3.343-4.428 0-2.576-1.89-4.921-5.58-4.921H.667v.04l1.74 1.7-1.74 1.703v15.863h10.52c3.69 0 5.638-2.315 5.638-5.21 0-2.43-1.657-4.428-3.72-4.746Zm-8.31-5.846h5.173c1.394 0 2.267.927 2.267 2.114 0 1.187-.872 2.142-2.267 2.142H4.793V3.825Zm5.318 12.301H4.793v-4.544h5.319c1.627 0 2.5 1.042 2.5 2.258 0 1.39-.93 2.286-2.5 2.286Z'
        />
    </SvgElement>
);
